function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Graphics } from "../../../core/render/Graphics";
import { Template } from "../../../core/util/Template";
import { ListTemplate } from "../../../core/util/List";
import { AxisTick } from "./AxisTick";
import { Grid } from "./Grid";
import { AxisLabel } from "./AxisLabel";
import * as $utils from "../../../core/util/Utils";
/**
 * Base class for an axis renderer.
 *
 * Should not be used on its own.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/#Axis_renderer} for more info
 */
export var AxisRenderer = /*#__PURE__*/function (_Graphics) {
  _inherits(AxisRenderer, _Graphics);
  var _super = _createSuper(AxisRenderer);
  function AxisRenderer() {
    var _this;
    _classCallCheck(this, AxisRenderer);
    _this = _super.apply(this, arguments);
    // save for quick access
    Object.defineProperty(_assertThisInitialized(_this), "_axisLength", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 100
    });
    Object.defineProperty(_assertThisInitialized(_this), "_start", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_end", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(_assertThisInitialized(_this), "_inversed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_minSize", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    /**
     * Chart the renderer is used in.
     */
    Object.defineProperty(_assertThisInitialized(_this), "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_lc", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(_assertThisInitialized(_this), "_ls", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_thumbDownPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downStart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downEnd", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * A list of ticks in the axis.
     *
     * `ticks.template` can be used to configure ticks.
     *
     * @default new ListTemplate<AxisTick>
     */
    Object.defineProperty(_assertThisInitialized(_this), "ticks", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), function () {
        return AxisTick._new(_this._root, {
          themeTags: $utils.mergeTags(_this.ticks.template.get("themeTags", []), _this.get("themeTags", []))
        }, [_this.ticks.template]);
      })
    });
    /**
     * A list of grid elements in the axis.
     *
     * `grid.template` can be used to configure grid.
     *
     * @default new ListTemplate<Grid>
     */
    Object.defineProperty(_assertThisInitialized(_this), "grid", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), function () {
        return Grid._new(_this._root, {
          themeTags: $utils.mergeTags(_this.grid.template.get("themeTags", []), _this.get("themeTags", []))
        }, [_this.grid.template]);
      })
    });
    /**
     * A list of fills in the axis.
     *
     * `axisFills.template` can be used to configure axis fills.
     *
     * @default new ListTemplate<Graphics>
     */
    Object.defineProperty(_assertThisInitialized(_this), "axisFills", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), function () {
        return Graphics._new(_this._root, {
          themeTags: $utils.mergeTags(_this.axisFills.template.get("themeTags", ["axis", "fill"]), _this.get("themeTags", []))
        }, [_this.axisFills.template]);
      })
    });
    /**
     * A list of labels in the axis.
     *
     * `labels.template` can be used to configure axis labels.
     *
     * @default new ListTemplate<AxisLabel>
     */
    Object.defineProperty(_assertThisInitialized(_this), "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), function () {
        return AxisLabel._new(_this._root, {
          themeTags: $utils.mergeTags(_this.labels.template.get("themeTags", []), _this.get("themeTags", []))
        }, [_this.labels.template]);
      })
    });
    /**
     * An [[Axis]] renderer is for.
     */
    Object.defineProperty(_assertThisInitialized(_this), "axis", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  /**
   * @ignore
   */
  _createClass(AxisRenderer, [{
    key: "makeTick",
    value: function makeTick(dataItem, themeTags) {
      var tick = this.ticks.make();
      tick._setDataItem(dataItem);
      dataItem.setRaw("tick", tick);
      tick.set("themeTags", $utils.mergeTags(tick.get("themeTags"), themeTags));
      this.axis.labelsContainer.children.push(tick);
      this.ticks.push(tick);
      return tick;
    }
    /**
     * @ignore
     */
  }, {
    key: "makeGrid",
    value: function makeGrid(dataItem, themeTags) {
      var grid = this.grid.make();
      grid._setDataItem(dataItem);
      dataItem.setRaw("grid", grid);
      grid.set("themeTags", $utils.mergeTags(grid.get("themeTags"), themeTags));
      this.axis.gridContainer.children.push(grid);
      this.grid.push(grid);
      return grid;
    }
    /**
     * @ignore
     */
  }, {
    key: "makeAxisFill",
    value: function makeAxisFill(dataItem, themeTags) {
      var axisFill = this.axisFills.make();
      axisFill._setDataItem(dataItem);
      axisFill.set("themeTags", $utils.mergeTags(axisFill.get("themeTags"), themeTags));
      this.axis.gridContainer.children.push(axisFill);
      dataItem.setRaw("axisFill", axisFill);
      this.axisFills.push(axisFill);
      return axisFill;
    }
    /**
     * @ignore
     */
  }, {
    key: "makeLabel",
    value: function makeLabel(dataItem, themeTags) {
      var label = this.labels.make();
      label.set("themeTags", $utils.mergeTags(label.get("themeTags"), themeTags));
      this.axis.labelsContainer.children.moveValue(label, 0);
      label._setDataItem(dataItem);
      dataItem.setRaw("label", label);
      this.labels.push(label);
      return label;
    }
  }, {
    key: "axisLength",
    value: function axisLength() {
      return 0;
    }
    /**
     * @ignore
     */
  }, {
    key: "gridCount",
    value: function gridCount() {
      return this.axisLength() / this.get("minGridDistance", 50);
    }
  }, {
    key: "_updatePositions",
    value: function _updatePositions() {}
  }, {
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      _get(_getPrototypeOf(AxisRenderer.prototype), "_afterNew", this).call(this);
      this.set("isMeasured", false);
      var thumb = this.thumb;
      if (thumb) {
        this._disposers.push(thumb.events.on("pointerdown", function (event) {
          _this2._handleThumbDown(event.originalEvent);
        }));
        this._disposers.push(thumb.events.on("globalpointerup", function (event) {
          _this2._handleThumbUp(event.originalEvent);
        }));
        this._disposers.push(thumb.events.on("globalpointermove", function (event) {
          _this2._handleThumbMove(event.originalEvent);
        }));
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(AxisRenderer.prototype), "_changed", this).call(this);
      if (this.isDirty("pan")) {
        var thumb = this.thumb;
        if (thumb) {
          var labelsContainer = this.axis.labelsContainer;
          var pan = this.get("pan");
          if (pan == "zoom") {
            labelsContainer.children.push(thumb);
          } else if (pan == "none") {
            labelsContainer.children.removeValue(thumb);
          }
        }
      }
    }
  }, {
    key: "_handleThumbDown",
    value: function _handleThumbDown(event) {
      this._thumbDownPoint = this.toLocal(this._root.documentPointToRoot({
        x: event.clientX,
        y: event.clientY
      }));
      var axis = this.axis;
      this._downStart = axis.get("start");
      this._downEnd = axis.get("end");
    }
  }, {
    key: "_handleThumbUp",
    value: function _handleThumbUp(_event) {
      this._thumbDownPoint = undefined;
    }
  }, {
    key: "_handleThumbMove",
    value: function _handleThumbMove(event) {
      var downPoint = this._thumbDownPoint;
      if (downPoint) {
        var point = this.toLocal(this._root.documentPointToRoot({
          x: event.clientX,
          y: event.clientY
        }));
        var downStart = this._downStart;
        var downEnd = this._downEnd;
        var extra = this._getPan(point, downPoint) * Math.min(1, downEnd - downStart) / 2;
        this.axis.setAll({
          start: downStart - extra,
          end: downEnd + extra
        });
      }
    }
  }, {
    key: "_getPan",
    value: function _getPan(_point1, _point2) {
      return 0;
    }
    /**
     * Converts relative position (0-1) on axis to a pixel coordinate.
     *
     * @param position  Position (0-1)
     * @return Coordinate (px)
     */
  }, {
    key: "positionToCoordinate",
    value: function positionToCoordinate(position) {
      if (this._inversed) {
        return (this._end - position) * this._axisLength;
      } else {
        return (position - this._start) * this._axisLength;
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateTooltipBounds",
    value: function updateTooltipBounds(_tooltip) {}
  }, {
    key: "_updateSize",
    value: function _updateSize() {
      this.markDirty();
      this._clear = true;
    }
  }, {
    key: "toAxisPosition",
    value: function toAxisPosition(position) {
      var start = this._start || 0;
      var end = this._end || 1;
      position = position * (end - start);
      if (!this.get("inversed")) {
        position = start + position;
      } else {
        position = end - position;
      }
      return position;
    }
    /**
     * @ignore
     */
  }, {
    key: "fixPosition",
    value: function fixPosition(position) {
      if (this.get("inversed")) {
        return 1 - position;
      }
      return position;
    }
  }, {
    key: "_updateLC",
    value: function _updateLC() {}
  }, {
    key: "toggleVisibility",
    value: function toggleVisibility(sprite, position, minPosition, maxPosition) {
      var axis = this.axis;
      var start = axis.get("start", 0);
      var end = axis.get("end", 1);
      var updatedStart = start + (end - start) * (minPosition - 0.0001);
      var updatedEnd = start + (end - start) * (maxPosition + 0.0001);
      if (position < updatedStart || position > updatedEnd) {
        sprite.setPrivate("visible", false);
      } else {
        sprite.setPrivate("visible", true);
      }
    }
  }, {
    key: "_positionTooltip",
    value: function _positionTooltip(tooltip, point) {
      var chart = this.chart;
      if (chart) {
        if (chart.inPlot(point)) {
          tooltip.set("pointTo", this._display.toGlobal(point));
        } else {
          tooltip.hide();
        }
      }
    }
  }, {
    key: "processAxis",
    value: function processAxis() {}
  }]);
  return AxisRenderer;
}(Graphics);
Object.defineProperty(AxisRenderer, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRenderer"
});
Object.defineProperty(AxisRenderer, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([AxisRenderer.className])
});